import React, { useEffect, useState } from 'react';
import { FormLayoutComposer, IFormLayoutProps } from 'components/common/form/renderer/FormLayoutComposer';
import { customTabProps, ITabProps } from 'components/common/form/layout/tab';
import useTemplateFormTools from 'components/common/form/hooks/useTemplateFormTools';
import FormTabContentDefaultStacks from 'components/common/form/layout/tab/FormTabContentDefaultStacks';
import { FormElementComponent } from 'components/common/form/element/FormElementComponent';

export default function DomainForm(props: IFormLayoutProps) {
    const infoTab = <InfoTab {...customTabProps(props, 'info')} />;

    const customProps = {
        ...props,
        customTabs: { info: infoTab },
    };

    return <FormLayoutComposer props={customProps} />;
}

function InfoTab(tabProps: ITabProps) {
    const { getElementProps, hookForm } = useTemplateFormTools(tabProps);
    const [showHelperText, setShowHelperText] = useState(false);

    const associatedResourcesGrid = tabProps.elementProps.form?.hookFormWatch('domainAssociatedResourcesGrid');

    useEffect(() => {
        setShowHelperText(associatedResourcesGrid ? associatedResourcesGrid.length == 0 : true);
        if (associatedResourcesGrid && associatedResourcesGrid.length == 0) {
            hookForm.hookFormSetValue('enabled_ind', 'N', { shouldDirty: false });
        }
    }, [associatedResourcesGrid]);

    const enableIndProps = getElementProps('enabled_ind');

    const enableIndPropsOverride = {
        ...enableIndProps,
        record: enableIndProps.record
            ? {
                  ...enableIndProps.record,
                  props: {
                      ...enableIndProps.record.props,
                      component: {
                          ...enableIndProps.record.props.component,
                          props: {
                              ...enableIndProps.record.props.component.props,
                              helperText: showHelperText ? enableIndProps.record.props.component.props.helperText : '',
                          },
                      },
                  },
              }
            : undefined,
    };

    return (
        <FormTabContentDefaultStacks {...tabProps}>
            <></>
            <>
                <FormElementComponent {...enableIndPropsOverride} />
                <FormElementComponent {...getElementProps('name')} />
                <FormElementComponent {...getElementProps('icon_id')} />
                <FormElementComponent {...getElementProps('description')} />
                <FormElementComponent {...getElementProps('instructions')} />
                <FormElementComponent {...getElementProps('domainAssociatedResourcesGrid')} />
                <FormElementComponent {...getElementProps('domainSuggestedPromptGrid')} />
            </>
        </FormTabContentDefaultStacks>
    );
}
